/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateClaimAccountRequest } from './CreateClaimAccountRequest';
import type { CreateClaimImageRequest } from './CreateClaimImageRequest';
import type { CreateClaimItemRequest } from './CreateClaimItemRequest';
export type CreateClaimRequest = {
    shopId: string;
    type: CreateClaimRequest.type;
    claimNo: string;
    estimatePrice?: number;
    importedAt: string;
    appointmentAt: string;
    customerFirstName: string;
    customerLastName: string;
    customerCitizenId?: string;
    customerPassportNo?: string;
    customerPhoneNumber: string;
    customerFacebookUrl?: string;
    customerLineId?: string;
    customerNote?: string;
    items: Array<CreateClaimItemRequest>;
    itemImages: Array<CreateClaimImageRequest>;
    brand: string;
    version: string;
    imei?: string;
    serialNumber?: string;
    battery?: number;
    defect?: string;
    lockType: CreateClaimRequest.lockType;
    lockPassword?: string;
    lockImage?: CreateClaimImageRequest;
    accounts?: Array<CreateClaimAccountRequest>;
    productNote?: string;
    guaranteeDay: number;
    guaranteeHtmlDetail: string;
    remark?: string;
    hirePrice?: number;
    deliveryDate?: string;
    selectedShopId?: string;
    deposit?: boolean;
};
export namespace CreateClaimRequest {
    export enum type {
        SELF = 'SELF',
        RECEIVE_CENTRAL = 'RECEIVE_CENTRAL',
        SEND_CENTRAL = 'SEND_CENTRAL',
    }
    export enum lockType {
        NONE = 'NONE',
        PIN = 'PIN',
        PASSWORD = 'PASSWORD',
        PATTERN = 'PATTERN',
    }
}

